export default {
  groups: {
    activity: 'Áreas de Atividade',
    article: 'Artigo',
    articleCta: 'CTA lateral',
    blog: 'Blog',
    built_solution: 'Solução Construída',
    cta: 'CTA',
    delivery: 'Entrega',
    feature: 'Destaque',
    hero: 'Hero',
    intro: 'Introdução',
    generalData: 'Dados gerais',
    mv: 'Missão e Visão',
    mvv: 'Missão, Visão e Valores',
    newsletter: 'Newsletter',
    services: 'Serviços',
    resume: 'Resumo',
    topics: 'Tópicos',
    value_proposition: 'Proposta de Valor',
    wework: "Como trabalhamos",
    whois: "Para quem é esse serviço",
  },
  labels:{
    security: 'Suas informações estão seguras. Utilizamos seus dados apenas para responder ao seu contato.',
    send:'Enviar mensagem',
  },
  fields: {
    bullet_file: 'Imagem de Bullet',
    bulletDark: 'Bullet para fundo escuro',
    bulletLight: 'Bullet para fundo claro',
    bullet_file: 'Imagem de Bullet',
    bullet1: 'Bullet 1',
    bullet2: 'Bullet 2',
    bullet3: 'Bullet 3',
    bullet4: 'Bullet 4',
    bullet5: 'Bullet 5',
    articleContent1: 'Conteúdo 1',
    articleContent2: 'Conteúdo 2',
    articleContent3: 'Conteúdo 3',
    articleMainImage: 'Imagem principal',
    articleReadTime: 'Tempo de leitura (minutos)',
    buttonText: 'Texto do botão',
    buttonText1: 'Texto do botão 1',
    buttonText2: 'Texto do botão 2',
    buttonText3: 'Texto do botão 3',
    buttonText4: 'Texto do botão 4',
    buttonText5: 'Texto do botão 5',
    category: 'Categoria',
    description: 'Descrição',
    description1: 'Descrição 1',
    description2: 'Descrição 2',
    description3: 'Descrição 3',
    description4: 'Descrição 4',
    description5: 'Descrição 5',
    email:'E-mail',
    feature: 'Destaque',
    feature1: 'Destaque 1',
    feature2: 'Destaque 2',
    feature3: 'Destaque 3',
    feature4: 'Destaque 4',
    feature5: 'Destaque 5',
    featureImage: 'Imagem do Destaque',
    heroFile: 'Imagem do Hero',
    heroIcon: 'Ícone do Hero',
    highlighted: 'Destacado',
    introFile: 'Imagem do Intro',
    icon: 'Icone',
    icon1: 'Icone 1',
    icon2: 'Icone 2',
    icon3: 'Icone 3',
    icon4: 'Icone 4',
    icon5: 'Icone 5',
    imageTag01: 'Imagem da Tag 1',
    imageTag02: 'Imagem da Tag 2',
    imageTag03: 'Imagem da Tag 3',
    imageTag04: 'Imagem da Tag 4',
    imageTag05: 'Imagem da Tag 5',
    imageTag06: 'Imagem da Tag 6',
    imageTag07: 'Imagem da Tag 7',
    imageTag08: 'Imagem da Tag 8',
    imageTag09: 'Imagem da Tag 9',
    imageText: 'Texto de Imagem',
    imageServiceList: 'Imagem da lista de serviços',
    introFile: 'Imagem do intro',
    label: 'Etiqueta',
    link: 'Link',
    resume: 'Resumo',
    scheduled_date: 'Publicar em',
    scheduled_hour: 'Hora',
    scheduled_minute: 'Minuto',
    serviceList: 'Digite os serviços separados por ";"',
    serviceType: 'Tipo de serviço',
    slug: 'Slug',
    slug1: 'Slug 1',
    slug2: 'Slug 2',
    slug3: 'Slug 3',
    slug4: 'Slug 4',
    slug5: 'Slug 5',
    subtitle: 'Subtítulo',
    subtitle1: 'Subtítulo 1',
    subtitle2: 'Subtítulo 2',
    subtitle3: 'Subtítulo 3',
    subtitle4: 'Subtítulo 4',
    subtitle5: 'Subtítulo 5',
    tag01: 'Tag 1',
    tag02: 'Tag 2',
    tag03: 'Tag 3',
    tag04: 'Tag 4',
    tag05: 'Tag 5',
    tag06: 'Tag 6',
    tag07: 'Tag 7',
    tag08: 'Tag 8',
    tag09: 'Tag 9',
    tags: 'Tags',
    text1: 'Texto 1',
    text2: 'Texto 2',
    text3: 'Texto 3',
    text4: 'Texto 4',
    text5: 'Texto 5',
    title: 'Título',
    title1: 'Título 1',
    title2: 'Título 2',
    title3: 'Título 3',
    title4: 'Título 4',
    title5: 'Título 5',
  }, 
  form:{
    cell: 'Celular',
    company:'Empresa',
    email:'E-mail',
    message:'Mensagem',
    name:'Nome',
    phone: 'Telefone',
    service: 'Serviço de interesse'
  },
  placeholders:{
    company:'Nome da sua empresa',
    email:'seu@email.com',
    message:'Conte-nos sua necessidade ou desafio',
    name:'Seu nome completo',
    service: 'Serviço de interesse'
  }
}
